// Your web app's Firebase configuration
const firebaseConfig = {

  apiKey: "AIzaSyAsbb9hVhNGBmtmM5eQ5MW4bGexB6QVSDs",
  authDomain: "befoody-4c297.firebaseapp.com",
  projectId: "befoody-4c297",
  storageBucket: "befoody-4c297.appspot.com",
  messagingSenderId: "313218985001",
  appId: "1:313218985001:web:70c5372dc3de09d4338038" 
  

  // apiKey: "AIzaSyAGN_PdJ9APGoFvi-TZ2sUUVgMeVeZ5pk0",
  // authDomain: "befoody-client-site.firebaseapp.com",
  // projectId: "befoody-client-site",
  // storageBucket: "befoody-client-site.appspot.com",
  // messagingSenderId: "415832776230",
  // appId: "1:415832776230:web:3a44683f7151159d36d0e7"
};

export default firebaseConfig;




// //.env.local

// REACT_APP_FIREBASE_API_KEY=AIzaSyAGN_PdJ9APGoFvi-TZ2sUUVgMeVeZ5pk0
// REACT_APP_FIREBASE_AUTH_DOMAIN=befoody-client-site.firebaseapp.com
// REACT_APP_FIREBASE_PROJECT_ID=befoody-client-site
// REACT_APP_FIREBASE_STORAGE_BUCKET=befoody-client-site.appspot.com
// REACT_APP_FIREBASE_MESSAGING_SENDER_ID=415832776230
// REACT_APP_FIREBASE_APP_ID=1:415832776230:web:3a44683f7151159d36d0e7

// // Config
// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
//   authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
//   projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
//   storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
//   messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
//   appId: process.env.REACT_APP_FIREBASE_APP_ID,
// };

// export default firebaseConfig;



